import MemberData from './member_data.vue'

export default {
    path: 'memberData',
    component: MemberData
}
